import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../../../../../@casino/ui/table';
import {setGetBonusesHistory} from '../../store/thunk/setGetBonusesHistory';
import {rowsHistory, columnsHistory, useStyles} from './heplers';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';

const HistoryBonusPersonal = ({search, setStep, selectId, setSelectId}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});

    React.useEffect(() => {
        dispatch(setGetBonusesHistory({
            bonus_label: 'bonus-personal',
            page: 1,
            rowsPerPage: 10,
            search: '',
            date_from: 0,
            date_to: new Date().getTime()
        }))
    }, [])

    const history = useSelector(state => state.personal.history);

    const getRow = React.useMemo(() => rowsHistory(history), [history]);

    return (
        <div >
            <div className={classes.wrapBlock}>
            <FormikContext.Provider value={formik}>
                    <form>
                        <div style={{
                            paddingLeft: 20,
                            background: '#1b2039', 
                            borderRadius: 8, 
                        }}>
                            <div style={{display: 'flex', marginRight: 12}}>
                                <label htmlFor="check" className={classes.wrapSwitch}>
                                    <span className={classes.manually}>Ручн. время</span>
                                    <Switch
                                        checked={formik.values.check}
                                        onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                        color="primary"
                                        name="checkedB"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </label>
                                <span className={classes.spo}>С</span>
                                <input 
                                    type={formik.values.check ? 'datetime-local' : 'date' }
                                    className={classes.datetime}
                                    value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                    onChange={(v) => {
                                        const date = new Date(v.target.value);
                                        if (!formik.values.check) {
                                            date.setHours(0);
                                            date.setMinutes(0);
                                            date.setSeconds(0);
                                            date.setMilliseconds(0);
                                        }

                                        formik.setFieldValue('date_from', date.getTime());

                                        dispatch(setGetBonusesHistory({
                                            bonus_label: 'bonus-personal',
                                            page: 1, 
                                            rowsPerPage: 10,
                                            search: '',
                                            date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                        }))
                                    }}
                                />
                                <span className={classes.spo}>ПО</span>
                                <input 
                                    type={formik.values.check ? 'datetime-local' : 'date' }
                                    style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                    value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                    onChange={(v) => {
                                        const date = new Date(v.target.value);
                                        if (!formik.values.check) {
                                            date.setHours(23);
                                            date.setMinutes(59);
                                            date.setSeconds(59);
                                            date.setMilliseconds(999);
                                        }

                                        formik.setFieldValue('date_to', date.getTime());

                                        dispatch(setGetBonusesHistory({
                                            bonus_label: 'bonus-personal',
                                            page: 1, 
                                            rowsPerPage: 10,
                                            search: '',
                                            date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                        }))
                                        
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
            <div className={classes.wrapBlock}>
                <Table
                    pagination
                    allPage={history.countPage}
                    width={1300}
                    perPage={10}
                    columns={columnsHistory}
                    rows={getRow}
                    changePage={(v) => dispatch(setGetBonusesHistory({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        bonus_label: 'bonus-personal',
                        search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetBonusesHistory({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        bonus_label: 'bonus-personal',
                        search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                    }))}
                    setStep={setStep}
                    selectId={selectId}
                    setSelectId={setSelectId}
                />   
            </div>
            
        </div>
        
    )
}

export default HistoryBonusPersonal;